// extracted by mini-css-extract-plugin
module.exports = {"middle":"navigationItems_middle__3sAuG","nav-link":"navigationItems_nav-link__2G4O6","nav-item":"navigationItems_nav-item__2Glk1"};